import createSpacing from "@material-ui/core/styles/createSpacing";

const spacing = createSpacing(8);

export default spacing;
